import React from 'react'
import NavButtonRow from './NavButtonRow.js'
import NavBar from './NavBar.js'
import { Container, Paper, Stack } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import PageFooter from './PageFooter.js'
import TitleRow from './TitleRow.js'

export function BomPageContainer({
    titleText,
    pgControlsArray,
    handlePgNav,
    validFence = true,
}) {
    // const sxStack = {
    //     flexDirection: { xs: 'column', sm: 'row' },
    //     width: '100%',
    //     flexWrap: {
    //         xs: 'wrap',
    //         sm: 'nowrap',
    //     },
    // }

    function returnContent(pgControlsArray) {
        const sxStack = {
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'nowrap',
            mb: { xs: 3, sm: 0 },
        }
        const len = pgControlsArray.length
        const arr = pgControlsArray.map((couple, idx) => {
            const mtVal = idx === 0 && len > 2 ? { mt: { xs: 5, sm: 0 } } : {}
            return (
                <Stack key={idx} sx={{ ...sxStack, ...mtVal }}>
                    {couple}
                </Stack>
            )
        })
        return <>{arr}</>
    }

    // const sxBigGrid = {}
    return (
        <Container
            maxWidth="md"
            sx={{
                maxWidth: { xs: '100%', sm: '95%' },
                mt: { xs: 2, sm: 4 },
                pl: { xs: 0.5, sm: 1 },
                pr: { xs: 0.5, sm: 1 },
            }}
        >
            <NavBar />
            <Paper elevation={8}>
                <Stack>
                    <TitleRow
                        handlePgNav={handlePgNav}
                        titleText={titleText}
                        bomGrid={false}
                    />
                    <Stack
                        justifyContent={'space-evenly'}
                        sx={{
                            minHeight: { xs: '36rem', md: '28rem' },
                        }}
                    >
                        {returnContent(pgControlsArray)}
                    </Stack>
                    <NavButtonRow
                        handlePgNav={handlePgNav}
                        validFence={validFence}
                    />
                </Stack>
            </Paper>

            <PageFooter />
        </Container>
    )
}
